module.exports = __webpack_public_path__ + "images/kaitori_bonus_lp/step-2-img-pc@3x_8741708de7ff573f5ad66e0b02a30568.png";